import { createContext, useContext } from "react";
var ContentModuleContext = createContext({});
var useContentModule = function() {
    var page = useContext(ContentModuleContext);
    if (!("content" in page) || !(page === null || page === void 0 ? void 0 : page.content)) {
        throw new Error("this component must be used within a ContentModuleContext.Provider");
    }
    return {
        getStationsMap: function() {
            var ref, ref1;
            return "stationsMap" in page.content ? page === null || page === void 0 ? void 0 : (ref = page.content) === null || ref === void 0 ? void 0 : (ref1 = ref.stationsMap) === null || ref1 === void 0 ? void 0 : ref1.content : {
                stations: [],
                boundingBox: null
            };
        }
    };
};
export { ContentModuleContext, useContentModule };
